import React from 'react';
import PropTypes from 'prop-types';
import InputWithLabelV2 from '../../../../components/composite/FormSets/InputWithLabelV2/InputWithLabelV2';
import { setFieldAndValidate } from '../../../../utils/field-utils';
import { userFieldSchemas } from '../../../../utils/validation-utils';

const FirstAndLastNameControlSet = ({
  firstName, setFirstName, lastName, setLastName, disabled = false,
}) => (
  <>
    <InputWithLabelV2
      id="firstName"
      label="First Name"
      autoComplete="given-name"
      value={firstName.value}
      maxLength="40"
      errorMsg={firstName.error}
      onChange={({ target: { value } }) => setFieldAndValidate(firstName, setFirstName, value, userFieldSchemas.firstName)}
      disabled={disabled}
    />

    <InputWithLabelV2
      id="lastName"
      label="Last Name"
      autoComplete="family-name"
      value={lastName.value}
      maxLength="40"
      errorMsg={lastName.error}
      onChange={({ target: { value } }) => setFieldAndValidate(lastName, setLastName, value, userFieldSchemas.lastName)}
      disabled={disabled}
    />
  </>
);

FirstAndLastNameControlSet.propTypes = {
  firstName: PropTypes.shape({
    value: PropTypes.string.isRequired,
    state: PropTypes.number.isRequired,
    error: PropTypes.string,
  }).isRequired,
  setFirstName: PropTypes.func.isRequired,
  lastName: PropTypes.shape({
    value: PropTypes.string.isRequired,
    state: PropTypes.number.isRequired,
    error: PropTypes.string,
  }).isRequired,
  setLastName: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

FirstAndLastNameControlSet.defaultProps = {
  disabled: false,
};

export default FirstAndLastNameControlSet;
